class Credits {
  constructor(el) {
    this.el = el
    this.initialize()
  }

  initialize() {
    this.bindUI()
    this.bindEvents()
  }

  bindUI() {
    this.ui = {}
    this.ui.$popin = document.querySelector('.js-popin')
    this.ui.$close = document.querySelector('.js-popin-close')
    this.isOpen = false
  }

  bindEvents() {  
    this.el.addEventListener('click', this.onClick.bind(this))
    this.ui.$close.addEventListener('click', this.onClose.bind(this))
  }

  onClick(e) {
    let target = e.currentTarget
    if (!target.matches('.js-credits')) return 

    let credits = target.getAttribute('data-credits')
    let popinContent = this.ui.$popin.querySelector('.js-popin-content')

    popinContent.innerHTML = credits
    this.ui.$popin.classList.add('is-active')
    this.trapFocus(this.ui.$popin)
  }

  onClose() {
    this.ui.$popin.classList.remove('is-active')
    let popinContent = this.ui.$popin.querySelector('.js-popin-content')
    popinContent.innerHTML = ""
    window.oldFocus.focus() 
    window.oldFocus = null
  }
  trapFocus(container) {
    const focusableElements = container.querySelectorAll('a, button');
    window.oldFocus = document.activeElement
    if (focusableElements.length === 0) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    container.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          container.setAttribute('aria-hidden',"true");
          container.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
            el.tabIndex = -1;
          });
          this.onClose();
        }
        if (e.key === 'Tab') {
            if (e.shiftKey) {
                if (document.activeElement === firstElement) {
                    e.preventDefault();
                    lastElement.focus();
                }
            } else {
                if (document.activeElement === lastElement) {
                    e.preventDefault();
                    firstElement.focus();
                }
            }
        }
    });
    console.log(firstElement);
    
    setTimeout(() => {
      firstElement.focus();
    }, 100);
  }
}

export default Credits
